module.exports = __webpack_public_path__ + "static/media/24UHCHR4.15c173e8.jpg";